<template>
  <div>
    <Loader ref="Loader"></Loader>
    <ErrorModal ref="ErrorModal"></ErrorModal>
    <SuccessModal ref="SuccessModal"></SuccessModal>
    <YesNoModal ref="YesNoModal"></YesNoModal>
    <v-flex md12>
      <v-card>
        <v-card>
          <v-toolbar dense color="secondary" dark>
            <v-toolbar-title>Customer-User Allocation</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field
              append-icon="search"
              v-model="search"
              placeholder="Search customer-allocations"
            ></v-text-field>
            <v-btn flat @click="close()">Cancel</v-btn>
          </v-toolbar>
        </v-card>
        <v-container>
          <v-card>
            <v-form @submit.prevent="SubmitForm" ref="form" v-model="valid">
              <v-layout justify-start row>
                <v-flex xs3 ma-2>
                  <v-select
                    v-model="UserType"
                    :items="userTypeItems"
                    label="Select user type"
                    item-text="Name"
                    item-value="ID"
                    :rules="fieldRules"
                    v-on:input="FetchSystemUsers"
                  ></v-select>
                </v-flex>
                <v-flex xs3 ma-2>
                  <v-autocomplete
                    v-model="SystemUser"
                    :items="systemUserItems"
                    label="Select user"
                    multiple
                    :item-text="text"
                    item-value="ID"
                    :rules="fieldRules"
                    :disabled="systemUserItems.length == 0"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs5 ma-2>
                  <v-autocomplete
                    v-model="Customer"
                    :items="CustomerList"
                    label="Select Customers"
                    item-text="Name"
                    item-value="ID"
                    :rules="fieldRules"
                    :disabled="!SystemUser"
                    multiple
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="SubmitForm" :disabled="!valid">Allocate</v-btn>
              </v-card-actions>
              <v-dialog v-model="dialog" max-width="350">
                <v-card>
                  <v-card-text>
                    <v-switch v-model="CanNotify" label="Can Notify"></v-switch>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="SubmitForm">Submit</v-btn>
                    <v-btn @click="dialog = false">Cancel</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-form>
          </v-card>
        </v-container>
        <!-- customer-user allocation table -->
        <v-container>
          <v-card>
            <v-layout ma-2 row wrap>
              <v-flex xs4>
                <v-combobox
                  v-model="SelectedCustomer"
                  label="Filter by customer"
                  :items="CustomerList"
                  item-text="Name"
                  item-value="ID"
                  @change="GetCustomerAllocations()"
                ></v-combobox>
              </v-flex>
              <v-flex xs4 ml-2>
                <v-combobox
                  v-model="SelectedSysUser"
                  label="Filter by system user"
                  :items="sysUserList"
                  item-text="FullName"
                  item-value="ID"
                  @change="GetAllocationsBySysUser()"
                ></v-combobox>
              </v-flex>
              <v-flex mt-1>
                <v-btn flat outline @click="ClearFilter()">Clear Filter</v-btn>
              </v-flex>
            </v-layout>
            <v-data-table
              :headers="headers"
              :items="items"
              :rows-per-page-items="[25,50,75,100]"
              :search="search"
            >
              <template slot="no-data">There are no records</template>
              <template slot="no-results">No matching records found</template>
              <template slot="headerCell" slot-scope="{ header }">
                <span
                  class="subheading font-weight-light text-success text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props">
                <td>{{ props.index+1 }}</td>
                <td>{{ props.item.SystemUserFullName }}</td>
                <td>{{ props.item.CustomerName }}</td>
                <td style="float:right;">
                  <v-menu dense bottom left>
                    <v-btn small slot="activator" color="primary" dark>
                      <v-icon>settings</v-icon>
                    </v-btn>
                    <div
                      v-if="HasAccess('USER_MANAGEMENT', 'MODIFY') || HasAccess('USER_MANAGEMENT', 'DELETE')"
                    >
                      <v-list dense v-for="(action, index) in actionItems" :key="index">
                        <v-list-tile
                          @click="PerformOperation(action, props.item)"
                          v-if="action.access == true"
                        >
                          <v-list-tile-action>
                            <v-icon color="primary darken-2">{{ action.icon }}</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-title>{{ action.title }}</v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </div>
                    <div v-else>
                      <v-list dense>
                        <v-list-tile>
                          <v-list-tile-title>
                            You have no options
                            available
                          </v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </div>
                  </v-menu>
                </td>
              </template>
            </v-data-table>
          </v-card>
        </v-container>
      </v-card>
    </v-flex>
  </div>
</template>

<script>
import JWT from "jsonwebtoken";
export default {
  data() {
    let self = this;

    return {
      SelectedCustomer: null,
      SelectedSysUser: null,
      CustomerList: [
        {
          ID: -1,
          Name: "All"
        }
      ],
      sysUserList: [],
      dialog: false,
      valid: false,
      userTypeItems: [],
      venueItems: [],
      systemUserItems: [],
      customerItems: [],
      SystemUser: null,
      Customer: null,
      UserType: null,
      CanNotify: false,
      Venue: null,
      items: [],
      customerUserLinkItems: [],
      form: {
        SystemUserID: null,
        CustomerID: null,
        CustomerVenueID: null,
        CanNotify: false
      },
      fieldRules: [v => !!v || "Field is required"],
      actionItems: [
        {
          type: "delete",
          title: "Delete",
          access: self.HasAccess("USER_MANAGEMENT", "DELETE"),
          icon: "delete"
        }
      ],
      headers: [
        {},
        {
          sortable: true,
          text: "System User",
          value: "SystemUserFullName"
        },
        {
          sortable: true,
          text: "Customer",
          value: "CustomerName"
        },
        {
          sortable: false,
          align: "right",
          text: "Actions"
        }
      ],
      items: [],
      search: null
    };
  },
  mounted() {
    let self = this;
    let tokenData = JWT.decode(localStorage["refreshToken"]);
    self.accountID = tokenData.ACCOUNT_ID;
    self.FetchUserTypes();
    self.FetchCustomers();
    self.FetchSysUsers();
    //self.FetchCustomerUserLinks();
  },
  methods: {
    text: item => item.Title + " " + item.FirstName + " " + item.LastName,
    FetchUserTypes() {
      let self = this;

      self.get(`Roles/Account?accountID=${self.accountID}`).then(response => {
        self.userTypeItems = response.data;
      });
    },
    FetchSystemUsers() {
      let self = this;
      self.systemUserItems = [];
      self.SystemUser = null;
      self.customerItems = [];
      self.Customer = null;
      self.venueItems = [];
      self.Venue = null;

      self.$refs.Loader.show(true);
      self.$refs.Loader.setText("Loading users...");
      self
        .get("SystemUser/getAll")
        .then(response => {
          response.data.forEach(user => {
            if (user.IsDeleted == false) {
              self.$refs.Loader.hide();
              response.data.forEach(el => {
                if (el.UserRoleID == self.UserType) {
                  self.systemUserItems.push(el);
                }
              });
            }
          });
        })
        .catch(error => {
          self.$refs.Loader.hide();
          self.$refs.ErrorModal.show();
          self.$refs.ErrorModal.setText(error.toString());
          self.systemUserItems = [];
        });
    },
    FetchCustomers() {
      let self = this;
      self.customerItems = [];
      self.Customer = null;
      self.venueItems = [];
      self.Venue = null;

      self
        .get("Customer")
        .then(response => {
          response.data.forEach(customer => {
            self.CustomerList.push(customer);
          });
          // self.customerItems = response.data;
        })
        .catch(error => {
          self.$refs.ErrorModal.show();
          self.$refs.ErrorModal.setText(error.toString());
          self.customerItems = [];
        });
    },
    FetchSysUsers() {
      let self = this;

      self.get(`SystemUser/getAll`).then(r => {
        self.sysUserList = r.data;
      });
    },
    GetCustomerAllocations() {
      let self = this;

      self.$refs.Loader.show(true);
      self.$refs.Loader.setText("Loading...");

      self.$nextTick(() => {
        self
          .get(
            `CustomerUserLink/FilterByCustomer?customerID=${self.SelectedCustomer.ID}`
          )
          .then(r => {
            self.$refs.Loader.hide();
            self.items = r.data;
          });
      });
    },
    GetAllocationsBySysUser() {
      let self = this;
      self.$refs.Loader.show(true);
      self.$refs.Loader.setText("Loading...");
      self.$nextTick(() => {
        self
          .get(
            `CustomerUserLink/FetchBySystemUser?systemUserID=${self.SelectedSysUser.ID}`
          )
          .then(r => {
            self.items = r.data;
            self.$refs.Loader.hide();
          });
      });
    },
    ClearFilter() {
      let self = this;

      self.items = [];

      self.SelectedCustomer = null;
      self.SelectedSysUser = null;
    },
    FetchCustomerUserLinks() {
      let self = this;

      self
        .get("CustomerUserLink")
        .then(response => {
          self.items = response.data;
        })
        .catch(error => {
          self.$refs.ErrorModal.show();
          self.$refs.ErrorModal.setText(error.toString());
          self.items = [];
        });
    },
    FetchVenues() {
      let self = this;
      self.venueItems = [];
      self.Venue = null;

      if (self.Customer > 0) {
        self
          .get("CustomerVenue/CustomerID?customerID=" + self.Customer)
          .then(response => {
            response.data.forEach(venue => {
              if (venue.IsDeleted == false) {
                self.venueItems.push(venue);
              }
            });
          });
      }
    },
    SubmitForm() {
      let self = this;

      let request = {
        SystemUserIdList: self.SystemUser,
        CustomerID: self.Customer[0],
        CanNotify: self.CanNotify
      };

      self
        .post(`CustomerUserLink/Exists`, {
          CustomerID: self.Customer[0],
          SystemUserList: self.SystemUser
        })
        .then(result => {
          if (result.data == false) {
            // doesnt exist already
            self.post("CustomerUserLink", request).then(result => {
              self.dialog = false;
              self.$refs.SuccessModal.show(); // success modal
              self.$refs.SuccessModal.setText("Customer allocated to user!");
              setTimeout(function() {
                self.$refs.SuccessModal.hide();
              }, 1000);
              //self.FetchCustomerUserLinks();
            });
            self.$refs.form.reset();
            self.valid = false;
          } else {
            self.$refs.ErrorModal.show();
            self.$refs.ErrorModal.setText(
              "This allocation already exists for one or more users."
            );
          }
        })
        .catch(error => {});
    },
    close() {
      let self = this;
      self.$router.push("/customers/dashboard");
    },
    PerformOperation(action, item) {
      let self = this;
      switch (action.type.toUpperCase()) {
        case "DELETE":
          {
            self.deleteItem(item);
          }
          break;
      }
    },
    deleteItem(item) {
      let self = this;
      self.$refs.YesNoModal.show(
        "Are you sure you want to delete this customer-user allocation?",
        function(yes) {
          if (yes == true) {
            self.$refs.Loader.show(true);
            self.$refs.Loader.setText("Deleting allocation...");
            self
              .delete(`CustomerUserLink?customerID=${item.ID}`)
              .then(result => {
                self.$refs.Loader.hide();
                if (result.data == true) {
                  var index = self.items.indexOf(item);
                  if (index > -1) {
                    self.items.splice(index, 1);
                  }
                }
              })
              .catch(error => {
                self.$refs.Loader.hide();
                self.$refs.ErrorModal.show();
                self.$refs.ErrorModal.setText(error.toString());
              });
          }
        }
      );
    }
  }
};
</script>